import { ReactNode } from "react";
import SKILLS from "../data/skills.json";
import { capitalize } from "../utils";

export interface Skill {
    icon: string;
    link: string;
    title?: string;
}

interface SkillAnchorProps {
    skill: string;
}

export default function SkillAnchor(props: SkillAnchorProps) {
    const skill = SKILLS[props.skill as keyof typeof SKILLS] as Skill;

    if (!skill) {
        throw new Error(`Unreported skill ${props.skill}`);
    }

    const title = skill.title ?? capitalize(props.skill);

    return (
        <a href={skill.link} target="_blank" rel="noopener noreferrer">
            <img
                className="inline w-4 mr-1 mb-1"
                src={`imgs/icons/${skill.icon}.svg`}
                alt={title}
            ></img>
            {title}
        </a>
    );
}

export function unescapeSkillAnchors(text: string) {
	let tokens: ReactNode[] = text.split("#");
	if (tokens.length <= 2) return text;
	for (let i = 1; i < tokens.length; i += 2) {
		const skillId = (tokens[i] as string).toLowerCase();
		tokens[i] = <SkillAnchor key={skillId} skill={skillId} />;
	}
	return tokens;
}
